import { message } from "antd";
import { getTokenDecode } from "../utils/security";

export function SecurityToken(history) {
  let decodeToken = getTokenDecode(sessionStorage.getItem("access_token"));
  console.log(decodeToken);
  if (!decodeToken || !decodeToken.iss) {
    history.push("/");
    message.error("Votre session a expiré, veuillez vous reconnecter");
    return true;
  } else {
    return false;
  }
}
